/**
 * ID Verification Fingerprint configuration.
 *
 * These values previously lived in the EPIC experiments
 * `AcademicIntegrity.enableIdVerificationFingerprint` (course allowlist) and
 * `AcademicIntegrity.idVerificationFingerprintExclusionList` (excluded learners).
 * Following GA the data rarely changes, so it is hardcoded here instead of
 * being fetched from EPIC. See ING-6227 / ING-6228.
 */

/**
 * Course ids for which ID verification fingerprinting is enabled.
 */
export const ID_VERIFICATION_FINGERPRINT_ENABLED_COURSES: readonly string[] = ['G8JqXl8VEeu8xgoxFomNmw'];

/**
 * User ids that are excluded from ID verification fingerprinting.
 * Add a learner's user id here to opt them out of fingerprinting.
 */
export const ID_VERIFICATION_FINGERPRINT_EXCLUSION_LIST: readonly string[] = [
  '67563874',
  '118036568',
  '110932339',
  '128176012',
  '91005146',
  '129344167',
  '22927484',
  '114818385',
  '126134397',
  '103790493',
  '99138177',
  '90938733',
  '38207039',
  '80545762',
];
